
export const insertElementsToNavbar = (insertSearch,insertStrefaKlienta) => {
   insertSearch(".navbar .navbar__right");
   insertStrefaKlienta(".navbar .navbar__right");
}
